import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { PAUSE_REASONS } from "../constants";

const PauseReasonModal = ({ isOpen, onClose, onConfirm, reasons = PAUSE_REASONS, compact = false }) => {
    const [selectedReason, setSelectedReason] = useState("");
    const [customReason, setCustomReason] = useState("");

    const handleConfirm = () => {
        onConfirm(selectedReason === "Other" ? customReason : selectedReason);
        setSelectedReason("");
        setCustomReason("");
        onClose();
    };

    const gridClass = compact ? "grid grid-cols-2 gap-2" : "grid grid-cols-3 gap-3";

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="fixed inset-0 flex items-end sm:items-center justify-center bg-black/40 z-50 p-4"
                    onClick={onClose}
                >
                    <motion.div
                        initial={{ y: compact ? 60 : 0, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ y: compact ? 60 : 0, opacity: 0 }}
                        className={`bg-surface p-5 sm:p-6 rounded-t-2xl sm:rounded-xl shadow-2xl w-full sm:w-96 border border-line ${compact ? "max-w-md" : ""}`}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h3 className="text-base font-semibold text-ink mb-4">
                            Why pause this task?
                        </h3>
                        <div className={gridClass}>
                            {reasons.map((reason) => (
                                <label
                                    key={reason}
                                    className={`cursor-pointer px-3 py-3 rounded-lg text-sm font-medium text-center shadow-sm transition min-h-[44px] flex items-center justify-center ${
                                        selectedReason === reason
                                            ? "bg-primary text-primary-contrast shadow-md"
                                            : "bg-surface-2 text-ink-secondary hover:bg-surface-3"
                                    }`}
                                >
                                    <input
                                        type="radio"
                                        name="reason"
                                        value={reason}
                                        checked={selectedReason === reason}
                                        onChange={() => setSelectedReason(reason)}
                                        className="hidden"
                                    />
                                    {reason}
                                </label>
                            ))}
                        </div>
                        {selectedReason === "Other" && (
                            <input
                                type="text"
                                value={customReason}
                                onChange={(e) => setCustomReason(e.target.value)}
                                placeholder="Enter custom reason..."
                                className="mt-4 w-full border border-line rounded-md p-3 text-sm bg-surface-2 text-ink min-h-[44px]"
                            />
                        )}
                        <div className="flex justify-end gap-3 mt-6">
                            <button
                                type="button"
                                onClick={onClose}
                                className="px-4 py-2.5 text-sm bg-surface-2 text-ink-secondary rounded-md hover:bg-surface-3 min-h-[44px]"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                onClick={handleConfirm}
                                disabled={
                                    !selectedReason ||
                                    (selectedReason === "Other" && !customReason)
                                }
                                className="px-4 py-2.5 text-sm bg-primary text-primary-contrast rounded-md hover:bg-primary-hover disabled:opacity-50 min-h-[44px]"
                            >
                                Confirm
                            </button>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default PauseReasonModal;
